interface Lead {
  id: string;
  title: string;
  contact: string;
  value: string;
  source: string;
  createdAt: string;
}

interface PipelineColumn {
  id: string;
  label: string;
  color: string;
  leads: Lead[];
}

const PIPELINE_COLUMNS: PipelineColumn[] = [
  {
    id: 'new',
    label: 'New',
    color: 'var(--color-info)',
    leads: [
      { id: '1', title: 'Wedding Video Package', contact: 'Amanda & Jason', value: '$3,500', source: 'Website', createdAt: '2 days ago' },
      { id: '2', title: 'Real Estate Tour', contact: 'Elite Realty', value: '$1,200', source: 'Referral', createdAt: '3 days ago' },
    ],
  },
  {
    id: 'qualified',
    label: 'Qualified',
    color: 'var(--color-warning)',
    leads: [
      { id: '3', title: 'Corporate Documentary', contact: 'TechCorp Inc.', value: '$8,000', source: 'LinkedIn', createdAt: '5 days ago' },
      { id: '4', title: 'Music Video', contact: 'DJ Stellar', value: '$4,200', source: 'Instagram', createdAt: '1 week ago' },
    ],
  },
  {
    id: 'proposal',
    label: 'Proposal Sent',
    color: 'var(--color-primary)',
    leads: [
      { id: '5', title: 'Product Launch Video', contact: 'NovaBrand', value: '$6,500', source: 'Website', createdAt: '1 week ago' },
    ],
  },
  {
    id: 'negotiation',
    label: 'Negotiation',
    color: '#e879f9',
    leads: [
      { id: '6', title: 'Event Coverage', contact: 'Metro Events', value: '$2,800', source: 'Referral', createdAt: '2 weeks ago' },
    ],
  },
  {
    id: 'won',
    label: 'Won',
    color: 'var(--color-success)',
    leads: [
      { id: '7', title: 'Brand Campaign', contact: 'Horizon Films', value: '$12,000', source: 'Existing Client', createdAt: '3 weeks ago' },
    ],
  },
];

export function LeadsPage() {
  const totalValue = PIPELINE_COLUMNS.flatMap((col) => col.leads)
    .reduce((sum, lead) => {
      const num = parseFloat(lead.value.replace(/[$,]/g, ''));
      return sum + num;
    }, 0);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
        <div>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '4px' }}>Leads Pipeline</h1>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem' }}>
            {PIPELINE_COLUMNS.flatMap((c) => c.leads).length} leads
            {' \u00B7 '}
            Total value: ${totalValue.toLocaleString()}
          </p>
        </div>
        <button
          style={{
            padding: '10px 20px',
            background: 'var(--color-primary)',
            color: '#fff',
            border: 'none',
            borderRadius: 'var(--radius-md)',
            fontWeight: 500,
            fontSize: '0.875rem',
          }}
        >
          + Add Lead
        </button>
      </div>

      {/* Kanban board */}
      <div
        style={{
          display: 'flex',
          gap: '16px',
          overflowX: 'auto',
          paddingBottom: '16px',
        }}
      >
        {PIPELINE_COLUMNS.map((column) => (
          <div
            key={column.id}
            style={{
              minWidth: '280px',
              flex: '0 0 280px',
              background: 'var(--color-surface)',
              border: '1px solid var(--color-border)',
              borderRadius: 'var(--radius-lg)',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {/* Column header */}
            <div
              style={{
                padding: '16px',
                borderBottom: '1px solid var(--color-border)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span
                  style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: column.color,
                  }}
                />
                <span style={{ fontSize: '0.875rem', fontWeight: 600 }}>
                  {column.label}
                </span>
              </div>
              <span
                style={{
                  padding: '2px 8px',
                  borderRadius: '999px',
                  fontSize: '0.75rem',
                  fontWeight: 500,
                  background: 'var(--color-bg)',
                  color: 'var(--color-text-muted)',
                }}
              >
                {column.leads.length}
              </span>
            </div>

            {/* Cards */}
            <div style={{ padding: '12px', display: 'flex', flexDirection: 'column', gap: '10px', flex: 1 }}>
              {column.leads.map((lead) => (
                <div
                  key={lead.id}
                  style={{
                    padding: '14px',
                    background: 'var(--color-bg)',
                    borderRadius: 'var(--radius-md)',
                    border: '1px solid var(--color-border)',
                    cursor: 'grab',
                  }}
                >
                  <div style={{ fontSize: '0.875rem', fontWeight: 500, marginBottom: '6px' }}>
                    {lead.title}
                  </div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', marginBottom: '10px' }}>
                    {lead.contact}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '0.875rem', fontWeight: 600, color: 'var(--color-success)' }}>
                      {lead.value}
                    </span>
                    <span style={{ fontSize: '0.6875rem', color: 'var(--color-text-muted)' }}>
                      {lead.source}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
